import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["option"];
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { Media, MediaLeft, MediaBody } from 'foundations-components/transitional/components/Media';
import { Flex } from 'foundations-components/components/Flex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import AssetThumbnail from 'personalization-lib/components/assetDetails/AssetThumbnail';
import AssetInfo from 'personalization-lib/components/assetDetails/AssetInfo';
import CrmObjectAvatar from 'personalization-lib/components/targeting/CrmObjectAvatar';
import { VARIANT_SELECT_MODES } from 'personalization-lib/constants/variantSelect';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VariantSelectOption = _ref => {
  var _option$assetData;
  let {
      option
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isAbmMode = option.mode === VARIANT_SELECT_MODES.ABM;
  // ABM options are titled with the CRM object they target, so their targeting is not repeated
  const showTargeting = !isAbmMode;
  return /*#__PURE__*/_jsx(Clickable, Object.assign({}, rest, {
    title: option.text,
    "data-test-id": "variant-select-option",
    children: /*#__PURE__*/_jsxs(Media, {
      paddingBlock: "200",
      paddingInline: "500",
      children: [/*#__PURE__*/_jsx(MediaLeft, {
        children: option.crmObjectTarget ? /*#__PURE__*/_jsx(CrmObjectAvatar, {
          objectTypeAndId: option.crmObjectTarget,
          displayName: option.text
        }) : /*#__PURE__*/_jsx(AssetThumbnail, {
          imgSrc: (_option$assetData = option.assetData) === null || _option$assetData === void 0 ? void 0 : _option$assetData.imgSrc,
          inlineSize: "65px",
          maxBlockSize: "40px",
          borderRadius: "200",
          borderWidth: "100",
          borderColor: "border-core-default",
          borderStyle: "solid"
        })
      }), /*#__PURE__*/_jsx(MediaBody, {
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "100",
          children: [/*#__PURE__*/_jsx(TruncateString, {
            children: option.text
          }), /*#__PURE__*/_jsx(AssetInfo, {
            targetingConfig: option.targetingConfig,
            targetingState: option.assetData.targetingState,
            publishStatus: option.assetData.publishStatus,
            showTargeting: showTargeting,
            loading: option.loading,
            error: option.error
          })]
        })
      })]
    })
  }));
};
export default VariantSelectOption;